import { render, staticRenderFns } from "./c_hot_word.vue?vue&type=template&id=79939b58&scoped=true"
import script from "./c_hot_word.vue?vue&type=script&lang=js"
export * from "./c_hot_word.vue?vue&type=script&lang=js"
import style0 from "./c_hot_word.vue?vue&type=style&index=0&id=79939b58&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79939b58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79939b58')) {
      api.createRecord('79939b58', component.options)
    } else {
      api.reload('79939b58', component.options)
    }
    module.hot.accept("./c_hot_word.vue?vue&type=template&id=79939b58&scoped=true", function () {
      api.rerender('79939b58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_hot_word.vue"
export default component.exports